import { Autocomplete, FormHelperText, TextField } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { IRootState } from '../../../../../../../redux/types'

interface VipTypesAutocompleteProps {
  value: null | number
  handleInputChange: any
}

export function VipTypesAutocomplete({ value, handleInputChange }: VipTypesAutocompleteProps) {
  const { t } = useTranslation(['global'])

  const { errorForm, msgForm } = useSelector((state: IRootState) => state.validator)

  const types = [
    { id: 0, name: t('admin.people.temporary') },
    { id: 1, name: t('admin.people.permanent') }
  ]

  const handleAutoCompleteChange = (type: null | { id: number }) => {
    let typeId: null | number = type !== null ? type.id : type

    handleInputChange('type', typeId)
  }

  return (
    <>
      <Autocomplete
        id="combo-box-types"
        disableClearable
        value={types.find((type: any) => type.id === value)}
        onChange={(_, value) => handleAutoCompleteChange(value)}
        options={types}
        getOptionLabel={(option: any) => (option.id !== undefined ? option.name : '')}
        renderInput={params => (
          <TextField {...params} label={t('action')} variant="filled" InputLabelProps={{ shrink: true }} />
        )}
      />
      <FormHelperText error={errorForm.type}>{msgForm.type}</FormHelperText>
    </>
  )
}
